export const landborder = [
  'Aruk',
  'Sambas Entikong',
  'entikong Metamauk',
  'Atambua Mota’ain',
  'Atambua Nanga Badaum Sanggau Napan',
  'Atambua Skouw',
  'Jayapura'
];
